class Key {
    constructor() {
        this._pressed = {};
        this._pressedVisually = {};
        this.pos = {
            1: 65,
            2: 83,
            3: 68,
            4: 70,
        };
        this.A = 65;  // songNote.pos: 1
        this.S = 83;  // songNote.pos: 2
        this.D = 68;  // songNote.pos: 3
        this.F = 70;  // songNote.pos: 4

        this.addKeyListeners();
    }

    addKeyListeners() {
        window.addEventListener('keydown', (e) => {
            this.onKeydown(e);
        });
        window.addEventListener('keyup', (e) => {
            this.onKeyup(e);
        });
    }

    isDown(keyCode) {
        return this._pressed[keyCode];
    }

    isDownVisually(keyCode) {
        return this._pressedVisually[keyCode];
    }

    onKeydown(e) {
        this._pressed[e.keyCode] = {
            pressed: true,
            repeat: !!this._pressed[e.keyCode]?.repeat
        };

        setTimeout(() => {
            if(Object.keys(this._pressed).length > 3 ) {
                this._pressed[e.keyCode].repeat = true;
            }
        }, 150);
        this._pressedVisually[e.keyCode] = true;
    }

    onKeyup(e) {
        delete this._pressedVisually[e.keyCode];
        let buffer = 300; // buffer for leniency
        setTimeout( () => {
            delete this._pressed[e.keyCode];
        }, buffer);
    }
}

export default Key;